export default __webpack_public_path__ + "static/media/jwk.3a3284b9.png";